import React, { useContext } from "react";
import { Route, Routes, Navigate } from "react-router";
import { authRoutes, publicRoutes } from "./router.link";
import Feature from "../feature";
import AuthFeature from "../authFeature";
import Login from "../auth/login";
import ResetPassword from "../auth/resetPassword";
import RequireAuth from "./RequireAuth";
import AccountVerification from "../auth/accountVerification";
import { AuthContext } from "../../context/authcontext";
import { useTenantRole } from "../../components/TenantRoleDisplay";
import ApiDocumentation from "../documentation";
import ExternalApproval from "../external/approval/ExternalApproval";

const HomeRedirect: React.FC = () => {
  const { auth, selectedTenantId } = useContext(AuthContext);
  const role = useTenantRole(selectedTenantId || "");

  if (!auth) {
    return <Navigate to="/login" replace />;
  }

  if (!role) {
    return <Navigate to="/dashboard/crm-dashboard" replace />;
  }

  if (role.role_key === "SUPERADMIN") {
    return <Navigate to="/dashboard/crm-dashboard" replace />;
  }

  if (role.role_key === "PLATFORM_ANALYST") {
    return <Navigate to="/dashboard/crm-dashboard" replace />;
  }

  return <Navigate to="/dashboard/crm-dashboard" replace />;
};

const ALLRoutes: React.FC = () => {
  return (
    <Routes>
      <Route path="/" element={<HomeRedirect />} />
      <Route path="/api/docs" element={<ApiDocumentation />} />
      <Route path="/external/approval" element={<ExternalApproval />} />
      <Route path="/external/approval/:id" element={<ExternalApproval />} />

      <Route element={<RequireAuth />}>
        <Route path="/login" element={<Login />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route path="/reset-password/:token" element={<ResetPassword />} />
        <Route path="/account-verification" element={<AccountVerification />} />
        <Route
          path="/account-verification/:token"
          element={<AccountVerification />}
        />

        <Route element={<Feature />}>
          {publicRoutes.map((route, idx) => (
            <Route path={route.path} element={route.element} key={idx} />
          ))}
        </Route>
        <Route element={<AuthFeature />}>
          {authRoutes
            .filter((r) => r.path !== "/api/docs")
            .map((route, idx) => (
              <Route path={route.path} element={route.element} key={idx} />
            ))}
        </Route>
      </Route>
    </Routes>
  );
};

export default ALLRoutes;
